const dev = {
    API_ENDPOINT_URL: 'https://oracle-dev.maffle.it/medicalstudio'
};


const prod = {
    API_ENDPOINT_URL: 'https://oracle.maffle.it/medicalstudio'
};

const getEnv = () => {
    console.log("PROCESS ENV", process.env.REACT_APP_ENV?.trim())
    switch (process.env.REACT_APP_ENV?.trim()) {
        case 'sviluppo':
            return dev
        case 'produzione':
            return prod
        default:
            return {
                API_ENDPOINT_URL: 'http://100.73.136.56:1338'
            };
    }
}

export const env = getEnv()
